<template>
  <v-container fluid>
    <v-data-iterator
      :items="payments"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar dark color="green darken-3 rounded" class="mb-4">
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
          />
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-spacer></v-spacer>
            <v-select
              v-model="sortBy"
              flat
              solo-inverted
              hide-details
              :items="keys"
              prepend-inner-icon="mdi-magnify"
              label="Sort by"
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn-toggle v-model="sortDesc" mandatory>
              <v-btn depressed color="green" :value="false">
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn depressed color="green" :value="true">
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-list>
          <template v-for="(payment, index) in props.items">
            <v-list-item :key="payment.id">
              <v-list-item-avatar size="65" v-if="payment.profilePicture">
                <img :src="payment.profilePicture" :alt="payment.name" />
              </v-list-item-avatar>
              <v-list-item-avatar size="65" v-else>
                <img src="https://thedriverx.com/assets/images/user.png" :alt="payment.name" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-bold"
                  v-text="payment.name"
                />
                <v-list-item-subtitle
                  v-text="$moment(payment.date).format('LLL')"
                />
                <v-list-item-subtitle v-text="payment.description" />
                <!-- <v-list-item-subtitle v-text="payment.email" /> -->
              </v-list-item-content>
              <v-list-item-action v-text="'$' + payment.amount" />
            </v-list-item>
            <v-divider
              v-if="index !== payments.length - 1"
              inset
              :key="payment.id + '' + payment.studentId"
            />
          </template>
        </v-list>
      </template>

      <!-- <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <span class="grey--text">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                text
                color="primary"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
              >
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span class="mr-4 grey--text">
            Page {{ page }} of {{ numberOfPages }}
          </span>
          <v-btn
            fab
            dark
            color="green darken-3"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab dark color="green darken-3" class="ml-1" @click="nextPage">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template> -->
    </v-data-iterator>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      itemsPerPageArray: [4, 8, 12],
      search: '',
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 4,
      sortBy: 'name',
      keys: ['Name', 'Email', 'Description', 'Date', 'Amount']
    }
  },
  props: {
    payments: {
      type: Array,
      required: true
    }
  },
  computed: {
    numberOfPages () {
      return Math.ceil(this.payments.length / this.itemsPerPage)
    },
    filteredKeys () {
      return this.keys.filter((key) => key !== 'Name')
    }
  },
  methods: {
    nextPage () {
      if (this.page + 1 <= this.numberOfPages) this.page += 1
    },
    formerPage () {
      if (this.page - 1 >= 1) this.page -= 1
    },
    updateItemsPerPage (number) {
      this.itemsPerPage = number
    }
  }
}
</script>
